import $ from "jquery";
import "jquery.cookie";
import { CART_API_BASE } from "../../../../plugins/bigcommerce/assets/js/src/public/config/wp-settings";


const CART_ID_COOKIE_NAME = "wp-bigcommerce_cart_id";
const CART_ITEM_COUNT_COOKIE_NAME = "wp-bigcommerce_cart_item_count";
const CART_PAGE_URL = "/cart/";

const disableElements = elementList => {
  elementList.forEach(item => {
    item.setAttribute("disabled", "disabled");
  });
};

const enableElements = elementList => {
  elementList.forEach(item => {
    item.removeAttribute("disabled");
  });
};

// get all the actionable elements in the cart
const cartActionElements = () => {
  const removeLinks = cartRemoveLinks();
  const quantityFields = cartQuantityFields();
  const checkoutButtons = checkoutButton();
  return [...removeLinks, ...quantityFields, ...checkoutButtons];
};

// Use event data and cookie to get the URL for a specific cart item
const getCartAPIURL = cartEvent => {
  const cartID = $.cookie(CART_ID_COOKIE_NAME);
  const cartItem = cartEvent.target.dataset.cart_item_id;
  return (cartID && cartID.length > 0 && cartItem && cartItem.length > 0)
    ? `${CART_API_BASE}/${cartID}${window.bigcommerce_i18n.cart.items_url_param}${cartItem}`
    : "";
};

// Pull  html data for the Cart page
export const wpCartPageUpdate = selector =>
  $.ajax({
    url: CART_PAGE_URL,
    method: "GET",
    context: $(selector)
  });


// send an update for a cart item
export const wpAPICartItemUpdate = (cartURL, queryString = "") =>
  $.ajax({
    url: `${cartURL}?${queryString}`,
    method: "PUT"
  });

// Delete an item from a cart
export const wpAPICartDeleteItem = cartURL =>
  $.ajax({
    url: `${cartURL}`,
    method: "POST"
  });

// event handler for quantity input
const handleQuantityUpdate = function (inputEvent) {
  const $target = $(inputEvent.target);
  if (!inputEvent.target.value) {
    return;
  }
  if (parseInt($target.val()) < parseInt($target.attr('min')) || parseInt($target.val()) > parseInt($target.attr('max'))) {
    return;
  }
  const cart = getCart();
  cart.classList.add("bc-updating-cart");
  disableElements(cartActionElements());

  const quantity = inputEvent.target.valueAsNumber;

  const cartURL = getCartAPIURL(inputEvent);
  const queryString = `quantity=${quantity}`;

  wpAPICartItemUpdate(cartURL, queryString)
    .then(function () {
      return getCartContents(".bc-cart");
    })
    .done(replaceCartFromServer)
    .fail(() => {
      window.location.reload();
    });

  return false;
};
const updateCount = function (cartElement) {
  const quantity = cartElement.find('.bc-cart-item__quantity-input').toArray().reduce(function (acc, item) {
    return acc = acc + parseInt($(item).val());
  }, 0);
  $.cookie(CART_ITEM_COUNT_COOKIE_NAME, quantity, { path: '/' });
};
// replace the cart data from an html string
const replaceCartFromServer = function (data) {
  const cartDOM = $.parseHTML(data);
  const cartBody = $(cartDOM).find(".bc-cart");
  this.replaceWith(cartBody);
  makeCartEditable();
  updateCount(cartBody)
  //display tax field if not in salon mode
  if (!salon_mode) {
    $('.bc-cart-tax').removeClass("hidden");
   }
};

const makeCartEditable = () => {
  bindCartEvents();
  enableElements(cartActionElements());
  const cart = getCart();
  cart.classList.remove("bc-updating-cart");
};

// get the full html for the page and return a selection
// in context
const getCartContents = selector => {
  return wpCartPageUpdate(selector);
};

// Remove a cart item in then api and replace cart with
// server rendered html
const handleItemRemoval = function (inputEvent) {
  const cart = getCart();
  cart.classList.add("bc-updating-cart");
  const cartURL = getCartAPIURL(inputEvent);
  const deleteURL = `${cartURL}/delete`;
  wpAPICartDeleteItem(deleteURL)
    .then(function () {
      return getCartContents(".bc-cart");
    })
    .done(replaceCartFromServer)
    .fail(() => {
      window.location.reload();
    });


  return false;
};

// Cart element retrievers
const cartQuantityFields = () => {
  return document.querySelectorAll('[data-js="bc-cart-item__quantity-si"]');
};
const cartRemoveLinks = () => {
  return document.querySelectorAll('[data-js="remove-cart-item-si"]');
};
const checkoutButton = () => {
  return document.querySelectorAll('[data-js="proceed-to-checkout"]');
};
const getCart = () => {
  return document.querySelector('[data-js="bc-cart"]');
};

// // add listeners to the cart elements
const bindCartEvents = () => {
  cartQuantityFields().forEach(el => {
    $(el).on("input, change", handleQuantityUpdate);
  });

  cartRemoveLinks().forEach(el => {
    el.addEventListener("click", handleItemRemoval);
  });

  $('.bc-cart-item-quantity').on('click', 'button', (event) => {
    let type = $(event.target).hasClass('decrease') ? 'decrease' : 'increase';
    let $input = $(event.delegateTarget).find('input');
    let max = parseInt($input.attr('max'));
    let min = parseInt($input.attr('min'));
    let current = parseInt($input.val());
    if (type === 'increase') {
      if (current === max) {
        return;
      }
      else {
        $input.val(current + 1).trigger('change');
      }
    }
    else {
      if (current === min) {
        return;
      }
      else {
        $input.val(current - 1).trigger('change');
      }
    }

  });

};


const init = () => {
  bindCartEvents();
};

export default init;

// add error message to cart for bc-cart-item__quantity-input field when amount is over the max or min

$(document).on('change', function () {
  $('.bc-cart-item').each(function () {
    var quantityInput = $(this).find('.bc-cart-item__quantity-input')
    var enteredValue = quantityInput.val();
    var max = parseInt(quantityInput.attr('max'));
    var min = parseInt(quantityInput.attr('min'));
    var num = parseInt(enteredValue);

    if (min > num || max < num) {

      $(this).find('.errorMsg').show();

    }

  });
});


// remove error message on cart page on click
// $(document).each(function(){
//   $(window).click(function(){$('.errorMsg').fadeOut();});

// });

// add error message to product form for bc-product-form__quantity-input field when amount is over the max or min
$(document).each(function () {
  $(document).on("change", ".bc-product-form__quantity-input", function () {
    var enteredValue = $(this).val();
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    var num = parseInt(enteredValue);
    if (min > num || max < num) {
      $('.bc-ajax-add-to-cart__message-wrapper').append('<p class="bc-ajax-add-to-cart__message bc-alert bc-alert--error">The selected product quantity is currently unavailable.</p>');
      $('p.bc-alert--success').addClass('hide');

    }
    else {

    }

    return false;

  });
});
  //display tax field if not in salon mode
$(document).ready(function() {
   if (!salon_mode) {
    $('.bc-cart-tax').removeClass("hidden");
   }
});

